export enum ItemMobileFiltersVisibilityStates {
  List,
  SortBy,
  FilterByCategory,
  FilterByPrice,
  FilterByKeyword,
}
